import { render, staticRenderFns } from "./AppSidenav.vue?vue&type=template&id=29abba2c"
import script from "./AppSidenav.vue?vue&type=script&lang=js"
export * from "./AppSidenav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports